import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteResAssMutation } from "../../services/appln";

export default function DeleteResourceAssessment(props: any): any {
  return (
    <DeletePanel
      deleteMutation={useDeleteResAssMutation}
      deleteArgs={{
        bandobastId: props.bandobastId,
        timeslotId: props.timeslotId,
        locationId: props.locationId,
        resourceAssessmentId: props.resourceAssessmentId,
      }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteResourceAssessmentTitle}
      confirmationDialogMsg={strings.deleteResourceAssessmentConfirmation}
      errorDialogTitle={strings.deleteResourceAssessmentFailedTitle}
      errorDialogMsg={strings.deleteResourceAssessmentFailedMsg}
    />
  );
}
